var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetPatientRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 132.873 132.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M8961.431,490.4a65.02,65.02,0,1,1-65.018-65.025A65.018,65.018,0,0,1,8961.431,490.4Z",
    transform: "translate(-8829.975 -423.955)",
    fill: "none",
    stroke: "#272427",
    strokeMiterlimit: 10,
    strokeWidth: 2.835
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M8912.475,462.332c-6.959.3-7.715,13.62-7.715,13.62s-.024,4.672-.043,10.654l-5.647-4.894V458.489h-4.548v23.223l-4.429,3.834c-.018-5.461-.04-9.594-.04-9.594s-.756-13.316-7.717-13.62-23.077,28.414-24.685,35.865c-1.537,7.123-1.5,17.367,9.855,17.461s16.985-.032,16.985-.032,5.408.879,5.561-4.416c.077-2.679.075-11.655.057-19.878l6.686-5.828,7.906,6.891c-.017,7.921-.017,16.253.059,18.815.152,5.3,5.559,4.416,5.559,4.416s5.639.124,16.988.032,11.388-10.338,9.853-17.461C8935.556,490.746,8919.437,462.032,8912.475,462.332Z",
    transform: "translate(-8829.975 -423.955)",
    fill: "none",
    stroke: "#272427",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetPatientRate);
export default __webpack_public_path__ + "static/media/TargetPatientRate.59ce0447.svg";
export { ForwardRef as ReactComponent };